import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  vtt: defineAsyncComponent(() => import("/app/layouts/vtt.vue").then(m => m.default || m))
}